export class JobApplicationExternalSource {
    public ExternalId: string
    public JobBoardName: string

    constructor () {
      this.ExternalId = ''
      this.JobBoardName = ''
    }

    initialize (externalSource: any) {
      this.ExternalId = externalSource.id
      this.JobBoardName = externalSource.name
      return this
    }
}
